import { NotificationInline } from '../../../Notification'
import { useDocFlowMappingWidgetSplitting } from '../../DocFlow.hooks'
import { DocFlowWidgetForm } from '../../DocFlowWidgetForm'

import { DocFlowMappingWidgetSplittingFields } from './DocFlowMappingWidgetSplittingFields'

function DocFlowMappingWidgetSplitting({
  activeWidget,
  index,
  name,
  ...restProps
}) {
  const {
    disabled,
    handleAddNotification,
    handleChangeAccuracy,
    handleClearFieldType,
    handleClickNext,
    handleClickPrevious,
    handleDebounceWidgetGetSelectedAreaInfo,
    handleGetSplittingSelectedAreaInfo,
    handlePrependNotification,
    handleRemoveAdditionalNotifications,
    handleRemoveNotification,
    hasError,
    initialValues,
    isLoading,
    nextButtonDisabled,
    notifications,
    unvisited,
    widgetDone,
    widgetNotifications,
  } = useDocFlowMappingWidgetSplitting({
    activeWidget,
    index,
    widgetName: name,
  })

  return (
    <DocFlowWidgetForm
      {...restProps}
      actionsProps={{
        disabled: isLoading || nextButtonDisabled,
      }}
      activeWidget={activeWidget}
      disabled={disabled}
      done={widgetDone && !hasError}
      hasError={hasError}
      index={index}
      initialValues={initialValues}
      name={name}
      unvisited={unvisited}
      onClickPrevious={handleClickPrevious}
      onSubmit={handleClickNext}
    >
      {notifications.map(item => (
        <NotificationInline {...item} key={item.text} />
      ))}

      <DocFlowMappingWidgetSplittingFields
        isLoading={isLoading}
        widgetDisabled={disabled}
        widgetNotifications={widgetNotifications}
        onAddNotification={handleAddNotification}
        onChangeAccuracy={handleChangeAccuracy}
        onClearFieldType={handleClearFieldType}
        onDebounceWidgetGetSelectedAreaInfo={
          handleDebounceWidgetGetSelectedAreaInfo
        }
        onGetSplittingSelectedAreaInfo={handleGetSplittingSelectedAreaInfo}
        onPrependNotification={handlePrependNotification}
        onRemoveAdditionalNotifications={handleRemoveAdditionalNotifications}
        onRemoveNotification={handleRemoveNotification}
      />
    </DocFlowWidgetForm>
  )
}

export default DocFlowMappingWidgetSplitting
